//Fil d'ariane
//--Déclarer un litige
if (window.location.href.indexOf("kolibri/declaration/formulaire") > -1) {
    $('.container-breadcrumb li').last().html('Faire une demande de prise en charge');
} else if (window.location.href.indexOf("declaration/formulaire") > -1) {
    $('.container-breadcrumb li').last().html('Déclarer un litige');
}


///
//Carousel
$('.slide-by-groups .item').each(function(){
   var itemToClone = $(this);

   for (var i=1;i<4;i++) {
     itemToClone = itemToClone.next();

     // wrap around if at end of item collection
     if (!itemToClone.length) {
       itemToClone = $(this).siblings(':first');
     }

     // grab item, clone, add marker class, add to collection
     itemToClone.children(':first-child').clone()
       .addClass("cloneditem-"+(i))
       .appendTo($(this));
   }
 });
